(function () {
  if (window.EagleroamTutorialLibraryLoaded) return;
  window.EagleroamTutorialLibraryLoaded = true;

  function activateVideo(poster) {
    var media = poster.closest('.ert-video-card__media');
    var player = media ? media.querySelector('[data-ert-player]') : null;
    if (!player) return;

    poster.hidden = true;
    player.hidden = false;

    var video = player.querySelector('video');
    if (video && typeof video.play === 'function') {
      video.play().catch(function () {});
    }

    var iframe = player.querySelector('iframe');
    if (iframe) {
      try {
        var source = new URL(iframe.src, window.location.href);
        source.searchParams.set('autoplay', '1');
        iframe.allow = (iframe.allow ? iframe.allow + '; ' : '') + 'autoplay';
        iframe.src = source.toString();
      } catch (error) {
        // Keep the provider URL unchanged if it cannot be parsed.
      }
    }
  }

  function initSeries(root) {
    if (!root || root.dataset.ertReady === 'true') return;
    root.dataset.ertReady = 'true';

    root.querySelectorAll('[data-ert-poster]').forEach(function (poster) {
      poster.addEventListener('click', function () {
        activateVideo(poster);
      });
    });

    root.querySelectorAll('[data-ert-filter]').forEach(function (filter) {
      filter.addEventListener('click', function () {
        var category = filter.dataset.ertFilter;

        root.querySelectorAll('[data-ert-filter]').forEach(function (item) {
          item.setAttribute('aria-pressed', item === filter ? 'true' : 'false');
        });

        root.querySelectorAll('[data-ert-card]').forEach(function (card) {
          card.hidden = category !== 'all' && card.dataset.ertCategory !== category;
        });
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ert-series]').forEach(initSeries);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
